import React, { forwardRef } from 'react';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import Slide from '@material-ui/core/Slide';
import Button from '@material-ui/core/Button';
import styles from './InvalidDatePopup.module.css';

const Transition = forwardRef(function Transition(props, ref) {
  return <Slide direction="down" ref={ref} {...props} />;
});

export default function InvalidDatePopup({open, invalidDataList, onDismiss}) {
  return (
    <Dialog
      open={open}
      classes={{
        root: styles.popupRoot,
        paper: styles.popupContainer,
      }}
      BackdropProps={{
        classes: {
          root: styles.backDrop,
        },
      }}
      TransitionComponent={Transition}
      keepMounted
      onClose={onDismiss}
      aria-labelledby="alert-dialog-slide-title"
      aria-describedby="alert-dialog-slide-description">
      <DialogTitle
        classes={{
          root: styles.popupTitle,
        }}
        id="alert-dialog-slide-title">
        Invalid dates
      </DialogTitle>
      <DialogContent
        classes={{
          root: styles.popupText,
        }}>
        <p>Please update <b>Date From</b> / <b>Date To</b> values to a new format in the following projects:</p> 
        <br />
        <ul className={styles.unorderedList}>
          {invalidDataList.map((value, id) => {
            return <li className={styles.list} key={id}>{value}</li>
          })}          
        </ul>
        <br />
        <p>
          It will let you sort all projects by date.
        </p>
      </DialogContent>
      <DialogActions
        classes={{
          root: styles.popupControls,
        }}>
        <Button aria-controls="simple-menu" aria-haspopup="true" onClick={onDismiss}>
          Ok
        </Button>
      </DialogActions>
    </Dialog>
  );
}
